
import { MIDDLEWARE } from "../constants/api";
import { getUserDetails } from "./getUserDetails";

export const extractDomain = () => {
  let domain = "";
  const url = window.location.origin;
  if (url.includes("localhost") || url.includes("test")) {
    domain = "https://recruiter.foundit.in";
  } else {
    domain = window.location.origin;
  }
  return domain;
};

export function callFromMiddleware(url: string): string {
  return `${MIDDLEWARE}${url}`;
}

export function extractBaseServer(url:string) {
  if (url.includes("localhost") || url.includes("test") ) {
    url = "recruiter.foundit.in";
  }

  const parts = url.split('.');
  const domain = parts[parts.length - 2] + '.' + parts[parts.length - 1];

  return domain;
}


export function formatDate(inputDate: string) {
  if (inputDate === null || '') return "NA"
  const options: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  };

  const parsedDate = new Date(inputDate);
  const formattedDate = parsedDate.toLocaleString("en-US", options);

  return formattedDate;
}

export function formatCommentsDate(inputDate: string) {
  if (inputDate === null) return "NA";

  const date = new Date(inputDate);
  const day = date.getDate();
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const month = monthNames[date.getMonth()];
  const year = date.getFullYear();
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const ampm = hours >= 12 ? "pm" : "am";
  const formattedHours = hours % 12 || 12;

  const formattedDate = `${day} ${month} ${year}, ${formattedHours}:${minutes.toString().padStart(2, '0')} ${ampm}`;

  return formattedDate;
}

export function formatDateWithoutTime(inputDate: string) {
  if (inputDate === null) return "NA"
  const options: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "short",
    day: "numeric",
  };

  const parsedDate = new Date(inputDate);
  const formattedDate = parsedDate.toLocaleString("en-US", options);

  return formattedDate;
}

export function transformString(inputString: string) {
  if (!inputString) return "";

  const words: string[] = inputString.split('_');

  const transformedString: string = words
    .map(word => word.toLowerCase())
    .join(' ');

  return transformedString.charAt(0).toUpperCase() + transformedString.slice(1);
}

export function getFolderRedirectionPath(id: number, sharedBy: number | null = null, isAutoMatch: boolean,isRevamp:boolean) {
  const domain = extractDomain();
  let url = `${domain}/edge/${!!isRevamp ?"recruiter-fm/folder-details" :"foldermanagement"}?folderID=${id}&autoMatch=${isAutoMatch}`;
  if (sharedBy) {
    url = url + `&sharedBy=${sharedBy}`;
  }
  return url;
}

export function getManageFolderRedirectionPath() {
  const domain = extractDomain();
  return `${domain}/edge/foldermanagement/manage-folder`;
}

export function getOutreachRedirectionPath(campaignInitiationDetails: any, timeZone: any) {
  const domain = extractDomain();
  return `${domain}/edge/recruiter-outreach-email/campaing/creation?initiationId=${campaignInitiationDetails?.id}&timeZone=${timeZone}&isBulkCampaign=${campaignInitiationDetails?.isBulkCampaign}`
}

export function getCDPRedirectionPath(profile_uuid: string, psc: string = '',fId:number|string,isRevamp:boolean) {
  const domain = extractDomain();
  const secondParam = psc ? `&psc=${psc}` : ''
  const thirdParam= fId ? `&folderId=${fId}` : ''
  return `${domain}/edge/${!isRevamp ?"recruiter-cdp/profile" :"recruiter-candidate/candidate"}?p_uuid=${profile_uuid}${secondParam}${thirdParam}`;
}


export function transformInsights(inputArray: string[], insightsMap: { key: string, text: string }[]): { key: string, text: string }[] {
  const transformedInsights = inputArray.map(item => {
    const insights = insightsMap.find((insight: { key: string, text: string }) => insight.key === item);
    return insights ? insights : { key: item, text: 'No Match Found' };
  });

  return transformedInsights.filter(insight => insight.text !== 'No Match Found');
}



export function getSearchRedirectionPath(id: number) {
  const domain = extractDomain();
  return `${domain}/edge/recruiter/edit-saved-search-v1?searchId=${id}&cn=in`;
};



interface DataItem {
  id: number;
  label: string;
  count?: number | null | undefined;
}


export function calculateSumOfProfileCount(data: DataItem[]): number {
  let sum = 0;
  for (const item of data) {
    if (item.hasOwnProperty('count')) {
      sum += item.count || 0;
    }
  }
  return sum;
}

export function capitalizeFirstLetters(inputString: string) {
  return inputString.replace(/\b\w/g, (match) => match.toUpperCase());
}

export function post(path:any, params:any, method = "post") {
  // The rest of this code assumes you are not using a library.
  // It can be made less verbose if you use one.
  const form = document.createElement("form");
  form.method = method;
  form.action = path;
  form.target = "_blank";

  for (const key in params) {
    if (params.hasOwnProperty(key)) {
      const hiddenField = document.createElement("input");
      hiddenField.type = "hidden";
      hiddenField.name = key;
      hiddenField.value = params[key];

      form.appendChild(hiddenField);
    }
  }
  document.body.appendChild(form);
  form.submit();
}

export const linkBuilderRecSrp = (endpoint:string, redirectToNewSrp:any) => {


  return (
    `${extractDomain()}/edge/recruiter/search-results-v1`
  );
};